import ErrorSnackBar from './error-snackbar';

export default ErrorSnackBar;
